var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEther(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5004 1.90039C12.2091 1.90039 11.9345 2.03639 11.758 2.26808L5.09134 11.0181C4.91245 11.2529 4.85517 11.5584 4.93688 11.8421C5.01859 12.1257 5.22965 12.354 5.50603 12.4576L12.1727 14.9576C12.384 15.0369 12.6168 15.0369 12.8281 14.9576L19.4948 12.4576C19.7711 12.354 19.9822 12.1257 20.0639 11.8421C20.1456 11.5584 20.0883 11.2529 19.9094 11.0181L13.2428 2.26808C13.0663 2.03639 12.7917 1.90039 12.5004 1.90039ZM13.4337 12.7369V5.59877L17.6637 11.1507L13.4337 12.7369ZM11.5671 12.7369L7.33705 11.1507L11.5671 5.59877V12.7369Z",
    fill: "#9B9DA1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.16145 13.6265C5.7501 13.4722 5.28686 13.6257 5.04902 13.9951C4.81117 14.3645 4.86313 14.8497 5.17377 15.1604L11.8404 21.827C12.2049 22.1915 12.7959 22.1915 13.1604 21.827L19.827 15.1604C20.1377 14.8497 20.1896 14.3645 19.9518 13.9951C19.7139 13.6257 19.2507 13.4722 18.8393 13.6265L12.5004 16.0036L6.16145 13.6265ZM12.5004 19.8471L9.5405 16.8872L12.1727 17.8743C12.384 17.9535 12.6168 17.9535 12.8281 17.8743L15.4603 16.8872L12.5004 19.8471Z",
    fill: "#9B9DA1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEther);
export default __webpack_public_path__ + "static/media/ether.91c505af62222978870f02f6d8d500b6.svg";
export { ForwardRef as ReactComponent };